import { notifications } from "@mantine/notifications"
import { UseMutationOptions, useMutation } from "@tanstack/react-query"
import { AxiosError } from "axios"

import { DeleteProductionSiteFieldDefinitionParams } from "@tfg/types/schemas/modules/traceability/queries/delete-production-site-field-definition.dto"

import { httpClient } from "~/backend/axios"
import { queryClient } from "~/backend/queryClient"

export const useDeleteProductionSiteFieldDefinitionMutation = (
  options?: UseMutationOptions<
    unknown,
    AxiosError,
    DeleteProductionSiteFieldDefinitionParams
  >
) =>
  useMutation({
    mutationFn: async ({ id }: DeleteProductionSiteFieldDefinitionParams) => {
      return await httpClient.delete(
        `/admin/traceability/delete-production-site-field-definition/${id}`
      )
    },
    onSuccess: (data, variables, context) => {
      options?.onSuccess?.(data, variables, context)
      queryClient.invalidateQueries(["prodSiteFieldDefs"])
      notifications.show({
        title: "Success",
        message: "Production field definition deleted",
        color: "green",
      })
    },
    onError: (error: AxiosError) => {
      notifications.show({
        title: "Error",
        message: error.message,
        color: "red",
      })
    },
  })
